/* ==========================================================================
   Starter Kit LP - subscription toggle
   --------------------------------------------------------------------------
   Replaces Skio's two-radio plan picker with an on/off switch card.

   The discount is NOT faked. Skio's <skio-plan-picker> is left in the DOM
   (visually hidden) and remains the source of truth: we click its real radio
   inputs inside the shadow root, and Skio does what it already does today -
   writes selling_plan into the product form and rewrites the Add to Cart
   price via its externalpriceselector. So the 15% survives to checkout and
   tracks whatever is configured in Skio.

   Loaded from snippets/sk-sub-toggle.liquid, gated to the
   starter-kit-sub product template.
   ========================================================================== */
(function () {
  'use strict';

  // The hook snippet can render more than once per page; only run once.
  if (window.__skSubToggle) return;
  window.__skSubToggle = true;

  var DEFAULT_ON = true; // the plan starts switched on
  var COPY = {
    titleHtml: 'Save Additional <b>{discount}</b> With Our Flexible Plan',
    benefits: [
      { icon: 'switch', text: 'Switch flavors anytime' },
      { icon: 'truck', text: 'Free shipping on every delivery' },
      { icon: 'pause', text: 'Pause, skip or cancel anytime' },
      { icon: 'gift', text: 'FREE rechargeable device with your first delivery' }
    ]
  };

  var ICONS = {
    switch:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 11a8 8 0 0 1 13.6-5.7L20 8"/><path d="M20 4v4.5h-4.5"/>' +
      '<path d="M21 13a8 8 0 0 1-13.6 5.7L4 16"/><path d="M4 20v-4.5h4.5"/></svg>',
    truck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M1.5 6.5h11v9h-11z"/><path d="M12.5 9.5h4.7l3.3 3.2v2.8h-8z"/>' +
      '<circle cx="6" cy="17.5" r="1.9"/><circle cx="16.5" cy="17.5" r="1.9"/></svg>',
    pause:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9"/><path d="M10 9v6M14 9v6"/></svg>',
    gift:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 9.5h18v3.5H3z"/><path d="M4.75 13h14.5v7h-14.5z"/><path d="M12 9.5V20"/>' +
      '<path d="M12 9.5S10.6 4.2 8.1 4.2a2.15 2.15 0 0 0 0 5.3z"/>' +
      '<path d="M12 9.5s1.4-5.3 3.9-5.3a2.15 2.15 0 0 1 0 5.3z"/></svg>'
  };

  var state = { on: DEFAULT_ON, planId: null };
  var cards = [];
  var syncing = false;

  /* ---------------------------------------------------------------- helpers */

  function pickers() {
    return Array.prototype.slice
      .call(document.querySelectorAll('skio-plan-picker'))
      .filter(function (p) {
        return p.shadowRoot && p.shadowRoot.querySelector('input[skio-selling-plan-group]');
      });
  }

  function subRadio(p) {
    return p.shadowRoot.querySelector('input[skio-selling-plan-group]');
  }

  function oneTimeRadio(p) {
    return p.shadowRoot.querySelector('input[skio-one-time]');
  }

  function freqSelect(p) {
    return p.shadowRoot.querySelector('select.skio-frequency');
  }

  function discountLabel(p) {
    var el = p.shadowRoot.querySelector('[skio-discount]');
    var txt = el && el.textContent ? el.textContent.trim() : '';
    return txt || '15%';
  }

  function freqOptions(p) {
    var sel = freqSelect(p);
    if (!sel) return [];
    return Array.prototype.slice.call(sel.options).map(function (o) {
      return { value: o.value, label: (o.text || '').replace(/\s+/g, ' ').trim() };
    });
  }

  /* -------------------------------------------------------- drive real Skio */

  // The price Skio should be showing for the current state.
  function expectedPrice() {
    var p = pickers()[0];
    if (!p) return null;
    var el = p.shadowRoot.querySelector(
      state.on ? '[skio-subscription-price]' : '[skio-onetime-price]'
    );
    var txt = el && el.textContent ? el.textContent.trim() : '';
    return txt || null;
  }

  function buttonText() {
    var b = document.querySelector('.quantity-submit-row__submit button');
    return b ? (b.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  // Clicking a shadow radio makes Skio re-render (lit), so always re-query.
  // bounce: click the *other* radio first. Skio only rewrites the external Add
  // to Cart price on an actual change, so when the theme has overwritten that
  // price after us, re-clicking the already-checked radio is a no-op and we
  // have to force a real transition.
  function pushToSkio(bounce) {
    syncing = true;
    pickers().forEach(function (p) {
      var wanted = state.on ? subRadio(p) : oneTimeRadio(p);
      var other = state.on ? oneTimeRadio(p) : subRadio(p);

      if (bounce && other) other.click();
      wanted = state.on ? subRadio(p) : oneTimeRadio(p); // re-query after re-render
      if (wanted && (bounce || !wanted.checked)) wanted.click();

      if (state.on && state.planId) {
        var sel = freqSelect(p);
        if (sel && sel.value !== state.planId) {
          sel.value = state.planId;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    // let Skio's async re-render settle before we trust its DOM again
    setTimeout(function () { syncing = false; }, 350);
  }

  // Confirm both that selling_plan landed on the form AND that the Add to Cart
  // button is showing the matching price. On first paint the theme writes the
  // button text after Skio does, which leaves the price stale even though the
  // plan is correct - so the price has to be verified separately.
  function pushAndVerify(attempt) {
    attempt = attempt || 0;
    pushToSkio(attempt > 0);
    setTimeout(function () {
      var input = document.querySelector('form.product-purchase-form input[name="selling_plan"]');
      var actual = input ? input.value : '';
      var planOk = state.on ? actual === String(state.planId) : actual === '';

      var want = expectedPrice();
      var priceOk = !want || buttonText().indexOf(want) > -1;

      if ((!planOk || !priceOk) && attempt < 6) pushAndVerify(attempt + 1);
    }, 600);
  }

  // The theme rewrites the Add to Cart price several times while the page is
  // loading, and its last write lands after any fixed retry window we pick -
  // which is why the button could sit at the one-time price even though the
  // subscription was correctly selected. Rather than race it, watch the button
  // and re-assert whenever it disagrees with Skio. Capped so a theme that
  // rewrites unconditionally can't cause a loop.
  function watchButton() {
    var row = document.querySelector('.quantity-submit-row__submit');
    if (!row || !window.MutationObserver) return;

    var fixes = 0;
    var timer = null;

    new MutationObserver(function () {
      if (syncing || fixes >= 8) return;
      var want = expectedPrice();
      if (!want || buttonText().indexOf(want) > -1) return;
      clearTimeout(timer);
      // wait for the burst of theme writes to go quiet, then correct once
      timer = setTimeout(function () {
        if (syncing) return;
        var stillWrong = expectedPrice();
        if (stillWrong && buttonText().indexOf(stillWrong) === -1) {
          fixes++;
          pushToSkio(true);
        }
      }, 300);
    }).observe(row, { childList: true, subtree: true, characterData: true });
  }

  // The theme rewrites the Add to Cart price during load, so the opening state
  // is only safe to apply once everything has settled.
  function whenSettled(fn) {
    if (document.readyState === 'complete') {
      setTimeout(fn, 600);
    } else {
      window.addEventListener('load', function () { setTimeout(fn, 600); }, { once: true });
    }
  }

  /* ------------------------------------------------------------ build cards */

  function buildCard(wrapper, picker) {
    var card = document.createElement('div');
    card.className = 'sk-st';

    var opts = freqOptions(picker);
    var optionHtml = opts
      .map(function (o) {
        return '<option value="' + o.value + '">' + o.label + '</option>';
      })
      .join('');

    card.innerHTML =
      '<div class="sk-st__card">' +
        '<div class="sk-st__head">' +
          '<p class="sk-st__title">' +
            COPY.titleHtml.replace('{discount}', discountLabel(picker)) +
          '</p>' +
          '<button type="button" class="sk-st__switch" role="switch" ' +
            'aria-label="Subscribe and save"></button>' +
        '</div>' +
        '<ul class="sk-st__benefits">' +
          COPY.benefits
            .map(function (b) {
              return '<li>' + ICONS[b.icon] + '<span>' + b.text + '</span></li>';
            })
            .join('') +
        '</ul>' +
      '</div>' +
      (opts.length
        ? '<div class="sk-st__freq"><select aria-label="Delivery frequency">' +
            optionHtml +
          '</select></div>'
        : '');

    var sw = card.querySelector('.sk-st__switch');
    sw.addEventListener('click', function () {
      state.on = !state.on;
      render();
      pushAndVerify();
    });

    var freq = card.querySelector('.sk-st__freq select');
    if (freq) {
      freq.addEventListener('change', function () {
        state.planId = freq.value;
        render();
        pushAndVerify();
      });
    }

    wrapper.appendChild(card);
    wrapper.classList.add('sk-st-ready');
    cards.push(card);
    return card;
  }

  function render() {
    cards.forEach(function (card) {
      card.classList.toggle('is-on', state.on);
      var sw = card.querySelector('.sk-st__switch');
      if (sw) sw.setAttribute('aria-checked', state.on ? 'true' : 'false');
      var freq = card.querySelector('.sk-st__freq select');
      if (freq && state.planId && freq.value !== state.planId) freq.value = state.planId;
    });
  }

  /* ------------------------------------------------- reflect outside changes */

  // Skio mirrors the live price onto [skio_price] as an attribute, so attribute
  // mutations there are a reliable signal that the plan changed elsewhere
  // (e.g. a variant swap resetting the picker).
  function watchSkio() {
    var mirror = document.querySelector('[skio_price]');
    if (!mirror || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (syncing) return;
      var input = document.querySelector('form.product-purchase-form input[name="selling_plan"]');
      var actual = input ? input.value : '';
      var actuallyOn = !!actual;
      if (actuallyOn !== state.on) {
        // something reset the picker - put it back where the user left it
        pushAndVerify();
      }
    }).observe(mirror, { attributes: true, attributeFilter: ['skio-price'] });
  }

  /* --------------------------------------------------- duplicate dropdown */

  // Only the first kit dropdown in the buy box should ever render.
  function dedupeKitDropdown() {
    var drops = document.querySelectorAll('.detail .flavour_drop, .product-form .flavour_drop');
    for (var i = 1; i < drops.length; i++) drops[i].classList.add('sk-st-dupe');
  }

  /* -------------------------------------------------------------- bootstrap */

  function init() {
    var ps = pickers();
    if (!ps.length) return false;

    // default frequency = whatever Skio has pre-selected (4 weeks today)
    if (!state.planId) {
      var sel = freqSelect(ps[0]);
      var first = freqOptions(ps[0])[0];
      state.planId = (sel && sel.value) || (first && first.value) || null;
    }

    ps.forEach(function (p) {
      var wrapper = p.closest('.skio-wrapper') || p.parentElement;
      if (!wrapper || wrapper.classList.contains('sk-st-ready')) return;
      // Never build inside the Add to Cart row. On mobile the theme turns that
      // row into the fixed bottom bar, and a card in there covers the page.
      // The bar stays a single button; the card lives in the page flow.
      if (wrapper.closest('.quantity-submit-row')) return;
      buildCard(wrapper, p);
    });

    if (!cards.length) return false;

    dedupeKitDropdown();
    render();
    watchButton(); // self-heals the price whenever the theme overwrites it
    whenSettled(function () {
      pushAndVerify(); // apply the default-on state
      watchSkio();
    });
    return true;
  }

  // Skio hydrates its shadow DOM asynchronously - poll briefly until it's there.
  function boot() {
    if (init()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (init() || tries > 60) clearInterval(timer); // ~15s ceiling
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
